if (!customElements.get("custom-reviews")) {
  customElements.define(
    "custom-reviews",
    class CustomReviewsNew extends HTMLElement {
      constructor() {
        super();
        this.jsonarr = [];
        this.producthandlereview = $(this).data("producthandlereview");

        this.loaddata();
        this.swiper = null;
      }

      connectedCallback() {
        const handleIntersection = (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
        };
        new IntersectionObserver(handleIntersection.bind(this), {
          rootMargin: "0px 0px 400px 0px",
        }).observe(this);
      }

      loaddata() {
        var csvurl = $(this).data("csvurl");
        console.log(csvurl);
        var href = new URL(csvurl);
        var random = Math.floor(Math.random() * 100000000);
        href.searchParams.set("v", random);
        csvurl = href.toString();

        var this3 = this;

        console.log("Fetching CSV from:", csvurl);

        $.ajax({
          type: "GET",
          url: csvurl,
          dataType: "text",
          success: function (data) {
            $.getScript(
              "https://cdnjs.cloudflare.com/ajax/libs/jquery-csv/0.71/jquery.csv-0.71.min.js",
              function () {
                try {
                  var csvData = data;
                  console.log("CSV data fetched:", csvData);
                  let word_array = $.csv.toArrays(csvData);

                  if (word_array.length < 2) {
                    throw new Error(
                      "CSV is either empty or improperly formatted."
                    );
                  }

                  for (let index = 1; index < word_array.length; index++) {
                    var ob = {};
                    ob["index"] = index;
                    ob["producthandle"] = word_array[index][0];
                    ob["rating"] = word_array[index][1];
                    ob["reviewheading"] = word_array[index][2];
                    ob["reviewcontent"] = word_array[index][3];
                    ob["authorinfo"] = word_array[index][4];
                    this3.jsonarr.push(ob);
                  }
                  console.log(this3.jsonarr);
                  this3.setDataInPage(
                    this3.jsonarr,
                    this3.producthandlereview,
                    1
                  );
                } catch (error) {
                  console.error("Error processing CSV data:", error);
                }
              }
            );
          },
          error: function (xhr, status, error) {
            console.error("Error fetching CSV:", error);
          },
        });
      }
      setDataInPage(data, handle, current) {
        var filteredData = data.filter((item) => item.producthandle === handle);

        var result = [];
        var datarr = filteredData;
        console.log(datarr);
        var str = "";
        result = datarr;
        result.forEach((item) => {
          str += `<div class="item">
                  <div class="item-container">
                    <div class="name-container">
                      <h3 class="name">${item.authorinfo}</h3>
                      <div class="verify-container">
                        <div class="icon">
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z" fill="black"/>
                            <path d="M6 9.66667L8 11.6667L12.6667 7" stroke="white" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </div>
                        <div class="text">Verified Buyer</div>
                      </div>
                    </div>
                    <div class="content-container">
                      <div class="star-container">
                  
                        <div class="star">`;
          for (let j = 1; j <= 5; j++) {
            str += `<svg
                              width="20"
                              height="19"
                              viewBox="0 0 20 19"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            > 
<path d="M10.0022 15.0355L14.7393 17.8963C14.8622 17.9696 15.0044 18.0054 15.1481 17.9993C15.2917 17.9932 15.4303 17.9454 15.5463 17.862C15.6623 17.7786 15.7505 17.6632 15.7998 17.5306C15.849 17.3979 15.8572 17.2539 15.8231 17.1167L14.535 11.7785L18.7509 8.20779C18.8583 8.1151 18.9358 7.99352 18.9738 7.85807C19.0117 7.72261 19.0084 7.57922 18.9643 7.44558C18.9202 7.31194 18.8372 7.19391 18.7256 7.10606C18.614 7.01821 18.4786 6.96439 18.3362 6.95124L12.8036 6.50915L10.6723 1.44214C10.618 1.31141 10.5252 1.19955 10.4059 1.1208C10.2865 1.04205 10.146 1 10.0022 1C9.85848 1 9.71797 1.04205 9.59863 1.1208C9.47929 1.19955 9.38655 1.31141 9.33221 1.44214L7.2009 6.50915L1.66831 6.95124C1.52492 6.9636 1.38843 7.01719 1.27587 7.1053C1.16331 7.19341 1.07969 7.31214 1.03545 7.44666C0.99121 7.58117 0.988312 7.72551 1.02712 7.86163C1.06593 7.99776 1.14472 8.11964 1.25365 8.21204L5.46953 11.7827L4.18139 17.1167C4.14734 17.2539 4.15546 17.3979 4.20473 17.5306C4.254 17.6632 4.3422 17.7786 4.4582 17.862C4.57419 17.9454 4.71277 17.9932 4.85641 17.9993C5.00006 18.0054 5.14232 17.9696 5.26523 17.8963L10.0022 15.0355Z"fill="${
              j <= item.rating ? "#3A4F3C" : "#ffffff"
            }" style="fill:${
              j <= item.rating ? "#3A4F3C" : "#ffffff"
            };" stroke="#3A4F3C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> </path> </svg>`;
          }
          str += `
                        </div>
                      <h4 class="text">${item.reviewheading}</h4>
                      </div>
                      <div class="content"><p>${item.reviewcontent}</p></div>
                    </div>
                  </div>
                </div>`;
        });

        console.log(str + " ddd");
        if (datarr.length == 0) {
          $(this).hide();
        }

        $(".review-inner-container").html(str);
        var itemsPerPage = 8;
        var itemsToShow = itemsPerPage;
        if (
          document.querySelectorAll(".reviews-container .item").length <= itemsToShow
        ) { 
          const showMoreReview = $("#show-more-review");
          if (showMoreReview.length) {
            showMoreReview.css("display", "none");
          }
        }
        setTimeout(function () {
          document
            .querySelectorAll(".reviews-container .item")
            .forEach(function (item, index) {
              if (index < itemsPerPage) {
                item.style.display = "block";
              }
            });

          document
            .getElementById("show-more-review")
            .addEventListener("click", function () {
              itemsToShow += itemsPerPage;

              document
                .querySelectorAll(".reviews-container .item")
                .forEach(function (item, index) {
                  if (index < itemsToShow) {
                    item.style.display = "block";
                    item.style.transition = "all 0.5s";
                  }
                });

              if (
                document.querySelectorAll(".reviews-container .item").length <=
                itemsToShow
              ) {
                this.style.display = "none";
              }
            });
        }, 1000);
      }
    }
  );
}
